import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-restart-day-dialog',
  templateUrl: './restart-day-dialog.component.html',
  styleUrls: ['./restart-day-dialog.component.scss'],
})
export class RestartDayDialogComponent {
  constructor(public dialogRef: MatDialogRef<RestartDayDialogComponent>) {
    dialogRef.disableClose = true;
    dialogRef.keydownEvents().subscribe((event) => {
      if (event.key === 'Escape') {
        this.onCancel();
      }
    });
  }

  public onConfirm(): void {
    this.dialogRef.close(true);
  }

  public onCancel(): void {
    this.dialogRef.close(false);
  }
}
